/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useNavigate,
  useLocation,
  Outlet,
  useParams,
  useSearchParams,
} from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router';

import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

import { isEmpty } from 'lodash';

import gtag, { install } from 'ga-gtag';

import uuid from 'lib/evi-api-gateway/utils/uuid';

import { setDeviceId } from 'slice/user';

import Page from '../components/Page';

// components
import Banner from '../components/home/Banner';
import MainHeader from './components/MainHeader';
import MainContent from './components/MainContent';
import MainFooter from './components/MainFooter';

import useLocales from '../hooks/useLocales';
// action
import { resetStepInfo } from '../redux/slice/step';

const langComparison = {
  zh: 'zh',
  english: 'en',
  cn: 'cn',
};

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'auto',
  flexDirection: 'column',
  height: '100vh',
  '@media print': {
    height: 'auto !important',
    display: 'inherit',
    overflow: 'visible',
    minHeight: 'inherit',
  },
});

// 需要隐藏banner的路由
const hideBannerPath = [
  'applications/receipt',
  'applications/view',
  'form_task',
  'interview',
  'interview-time',
  'interview-success',
];

const Main = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  const { lang } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  // const { default_lang } = useSelector((state) => state.main?.info);
  const search = searchParams.toString();
  const [isPrint, setPrint] = useState(searchParams.get('style') === 'print');
  const { device_id } = useSelector((state) => state.user);
  const { counter, info } = useSelector((state) => state.main);
  const { readMode } = useSelector((state) => state.step);

  const { i18n } = useTranslation();
  useEffect(() => {
    if (!device_id) {
      dispatch(setDeviceId(uuid()));
    }
  }, [dispatch]);

  useEffect(() => {
    setPrint(searchParams.get('style') === 'print');
  }, [search]);

  const isHomePage = useMemo(
    () => pathname === `/${langComparison[i18n.language]}`,
    [pathname, i18n.language]
  );

  // 网上入学申请表
  const handleClick = () => {
    navigate('applications');
  };

  // 点击更改或打印资料
  const handleClickEdit = () =>
    navigate('profile', { state: { isClickTo: true } });

  useEffect(() => {
    if (info?.ga_tag) {
      console.log('gtag :', info?.ga_tag);
      install(info?.ga_tag);
      gtag('config', info?.ga_tag);
    }
  }, [info?.ga_tag]);

  useEffect(() => {
    // 重置用户填写信息
    if (isHomePage) {
      dispatch(resetStepInfo());
      localStorage.removeItem('printFormItems');
      localStorage.removeItem('printInfo');
    }
  }, [isHomePage]);

  // 判断路由是否隐藏banner
  const hideBanner = useMemo(
    () =>
      !hideBannerPath
        .map((item) => `/${lang}/${item}`)
        .find((item) => pathname.startsWith(item)),
    [pathname]
  );

  return (
    <Page title={process.env.REACT_APP_TITLE} icon={process.env.REACT_APP_ICON}>
      <RootStyle
        sx={{
          '@media print': {
            height: 'auto !important',
          },

          '&::-webkit-scrollbar': {
            width: 6,
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            background: 'rgba(0,0,0,.1)',
          },
          '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
          },
        }}
      >
        {!isPrint && !readMode && <MainHeader />}
        <div style={{ flex: 1 }}>
          {hideBanner && !readMode && <Banner />}
          <Container
            maxWidth="lg"
            sx={{ padding: '0 15px', minHeight: '364px' }}
          >
            {/* // 二选一盒子 */}
            {isHomePage && (
              <MainContent
                handleClick={handleClick}
                handleClickEdit={handleClickEdit}
              />
            )}
            <Outlet />
          </Container>
        </div>
        {!isPrint && !readMode && <MainFooter />}
      </RootStyle>
    </Page>
  );
};

export default Main;
